import React from 'react'
import Header from '../../components/header/Header'
import Footer from '../../components/footer/Footer'

const Terms = () => {
    return (
        <>
            <Header />
            <section className='ourServices'>
                <div className="container">
                    <div className="osLeft" style={{width:"100%"}}>
                        <h2>Terms & Conditions</h2>
                    </div>
                    {/* <div className="osRight">
                        <p style={{ marginBottom: "0px" }} >Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>

                    </div> */}
                </div>
            </section>
            <section className='blogContentArea'>

                <div className="container">

<div className="blogContent">
    <p>
    Last updated: December 17, 2024

    </p>
    <p>
    Welcome to iLine.ai. These Terms and Conditions ("Terms") govern your use of the iLine.ai 
platform ("Platform") and the services offered through it ("Services"). By accessing or using the 
Platform, you agree to comply with and be bound by these Terms. If you do not agree with these 
Terms, please refrain from using the Platform.
    </p>
</div>
                    <div className="blogContent">

                        <h2>Definitions
                        </h2>
                        <p>
                            <strong style={{ color: "#172039" }}>"Company"</strong> refers to I-LINE.AI SOLUTIONS PRIVATE LIMITED, including its affiliates and
                            subsidiaries.
                        </p>
                        <p><strong style={{ color: "#172039" }}>"User"</strong> refers to any individual or entity accessing or using the Platform.
                        </p>
                        <p><strong style={{ color: "#172039" }}> "Consignment"</strong> refers to any goods transported or to be transported via the Services
                            provided by the Company.
                        </p>
                        <p><strong style={{ color: "#172039" }}>"Dangerous Goods"</strong>refers to items classified as hazardous, illegal, or otherwise prohibited
                            under applicable laws or Company policies.
                        </p>
                        <p><strong style={{ color: "#172039" }}>"Applicable Law"</strong> refers to all relevant statutes, rules, regulations, and ordinances
                            governing the use of the Platform and Services.</p>
                    </div>
                    <div className="blogContent">
                        <h2>User Obligations

                        </h2>
                        <p> <strong style={{ color: "#172039" }}>Accurate Information:</strong> Users must provide accurate and complete information about their
                            consignments, including weight, dimensions, and nature of the goods.
                        </p>
                        <p><strong style={{ color: "#172039" }}>Compliance with Laws:</strong> Users shall comply with all Applicable Laws related to the
                            transportation of goods, including obtaining necessary permits, licenses, and insurance.</p>
                        <p><strong style={{ color: "#172039" }}>Prohibited Items:</strong> Users agree not to ship Dangerous Goods, Valuables (e.g., cash,
                            jewelery, precious stones), or any items prohibited by the Company’s policies or stands
                            prohibited by the Government.
                        </p>
                        <p><strong style={{ color: "#172039" }}>Insurance Requirement:</strong> If the consignment’s value exceeds INR 15,000, Users must
                            secure appropriate insurance from a licensed provider. Failure to do so renders the shipment
                            entirely at the User’s risk.</p>
                    </div>

                    <div className="blogContent">
                        <h2>Service Terms
                        </h2>
                        <p>
                            <strong style={{ color: "#172039" }}>Scope of Services:</strong> The Company provides a logistics platform to facilitate the
                            transportation of goods. The Company does not directly own or operate vehicles but partners
                            with third-party providers.
                        </p>
                        <p><strong style={{ color: "#172039" }}>Force Majeure:</strong> The Company shall not be liable for delays or failures caused by factors
                            beyond its reasonable control, including acts of God, pandemics, civil unrest, or technical
                            disruptions.</p>
                        <p><strong style={{ color: "#172039" }}>Rejection of Consignment:</strong> If a receiver refuses to accept delivery, the Company will
                            attempt to contact the User for further instructions. Users are responsible for any additional
                            costs incurred due to forwarding, disposal, or return of such consignments.</p>
                        <p><strong style={{ color: "#172039" }}>Third-Party Claims:</strong> Users agree not to permit third parties to bring claims against the
                            Company. Users shall indemnify the Company against any costs or damages arising from such
                            claims.</p>


                    </div>

                    <div className="blogContent">
                        <h2>Payment Terms
                        </h2>
                        <p> <strong style={{ color: "#172039" }}>Fees and Charges:</strong> Users agree to pay all applicable fees, including base charges, toll fees,
                            and any additional costs for remote locations.
                        </p>
                        <p><strong style={{ color: "#172039" }}>Payment Deadlines:</strong> Invoices must be settled within seven (7) days unless otherwise
                            agreed in writing. Late payments may incur an administration fee (Only applicable for Enterprise
                            users)</p>
                        <p><strong style={{ color: "#172039" }}>Non-Payment by Third Parties:</strong> If the User designates a receiver or third party for payment
                            and they fail to pay, the User remains liable for the full amount plus applicable fees.</p>
                        <p><strong style={{ color: "#172039" }}>Taxes:</strong> All charges are subject to Goods and Services Tax (GST) as per Applicable Law.
                        </p>
                    </div>


                    <div className="blogContent">
                        <h2> Liability and Indemnification
                        </h2>
                        <p>
                            <strong style={{ color: "#172039" }}>Limited Liability:</strong> The Company disclaims all liability for loss, damage, or theft of goods
                            during transit unless caused by gross negligence or willful misconduct.

                        </p>
                        <p><strong style={{ color: "#172039" }}>User Responsibility:</strong> Users shall indemnify and hold the Company harmless from any
                            claims, damages, or expenses arising from:</p>
                        <ul className='Bullets'>
                            <li>Misrepresentation of consignment details.</li>
                            <li>Breach of Applicable Laws.</li>
                            <li>Shipping Dangerous Goods or prohibited items.</li>
                        </ul>
                        <p><strong style={{ color: "#172039" }}>Valuables and Non-Insured Goods:</strong> The Company is not liable for Valuables or
                            consignments not adequately insured.
                        </p>
                    </div>


                    <div className="blogContent">
                        <h2> Dangerous Goods and Prohibited Items
                        </h2>
                        <p>
                            <strong style={{ color: "#172039" }}>Prohibited Items:</strong> Users agree not to ship items deemed illegal, hazardous, or otherwise
                            restricted under Applicable Laws or the Company’s policies.
                        </p>
                        <p>
                            <strong style={{ color: "#172039" }}>Dangerous Goods:</strong> Shipments containing Dangerous Goods are accepted only with prior
                            written approval and compliance with applicable regulations. A surcharge will apply.

                        </p>
                        <p>
                            <strong style={{ color: "#172039" }}>Indemnity:</strong> Users shall indemnify the Company for any claims, damages, or penalties
                            arising from the transportation of prohibited or Dangerous Goods.
                        </p>

                    </div>



                    <div className="blogContent">
                        <h2> Dispute Resolution
                        </h2>
                        <p><strong style={{ color: "#172039" }}>Governing Law:</strong> These Terms shall be governed by and construed in accordance with the
                            laws of India.</p>
                        <p> <strong style={{ color: "#172039" }}>Jurisdiction:</strong> Any disputes arising from these Terms or the use of Services shall be subject
                            to the exclusive jurisdiction of the courts of Gautam Buddha Nagar, Uttar Pradesh.</p>

                    </div>


                    <div className="blogContent">
                        <h2> Miscellaneous
                        </h2>

                        <p><strong style={{ color: "#172039" }}>Termination:</strong> The Company reserves the right to terminate or suspend access to the
                            Platform or Services for violations of these Terms.</p>
                        <p><strong style={{ color: "#172039" }}>Changes to Terms:</strong> The Company may update these Terms at its sole discretion. Users are
                            responsible for reviewing the updated Terms periodically.</p>
                        <p><strong style={{ color: "#172039" }}>Entire Agreement:</strong> These Terms, along with the Privacy Policy, constitute the entire
                            agreement between the User and the Company.
                        </p>
                        <p><strong style={{ color: "#172039" }}>Grievance Officer:</strong> For any grievances, please contact:</p>
                        <ul className='Bullets'>
                            <li><strong style={{ color: "#172039" }}>Name:</strong> Grievance Officer</li>
                            <li><strong style={{ color: "#172039" }}>Email:</strong> grievance.officer@iline.ai
                            </li>
                            <li><strong style={{ color: "#172039" }}>Address:</strong> I-LINE.AI SOLUTIONS PRIVATE LIMITED, D-9, Sector-3, Noida, Gautam
                                Buddha Nagar, Uttar Pradesh, India-201301.</li>
                        </ul>
                    </div>


                    <div className="blogContent">
                        <h2> Disclaimer
                        </h2>

                        <p>
                        <strong style={{ color: "#172039" }}>No Warranty:</strong> The Platform and Services are provided "as is" without warranties of any kind. 
                        The Company does not guarantee uninterrupted, timely, or error-free services.
                        </p>
                        <p>
                        <strong style={{ color: "#172039" }}>Limitation of Liability:</strong> The Company shall not be liable for indirect, incidental, or 
consequential damages arising from the use of the Platform or Services.

                        </p>
                        <p>
                        <strong style={{ color: "#172039" }}>External Links:</strong> The Platform may contain links to third-party websites. The Company is not 
                        responsible for the content or reliability of these websites.
                        </p>
                        
                    </div>

<div className="blogContent">
    <p>By using the Platform, you acknowledge that you have read, understood, and agree to these 
Terms and Conditions. For further assistance, please contact our support team.
</p>
</div>

<div className="blogContent">
    <h2>Contact Information:</h2>
    <ul>
        <li> <strong style={{ color: "#172039" }}>Company Name:</strong> I-LINE.AI SOLUTIONS PRIVATE LIMITED
        </li>
        <li><strong style={{ color: "#172039" }}>Address:</strong> D-9, Sector-3, Noida, Gautam Buddha Nagar, Uttar Pradesh, India-201301
        </li>
        <li><strong style={{ color: "#172039" }}>Email:</strong> info@iline.ai</li>
    </ul>
</div>
                  

                </div>

            </section>
            <Footer />

        </>
    )
}

export default Terms
